import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "49",
  height: "49",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#155EEF",
  d: "M33.112 38.752H13.876V11.417H32.1v13.667a1.012 1.012 0 1 0 2.024 0v-14.68a1.012 1.012 0 0 0-1.012-1.012H12.864a1.012 1.012 0 0 0-1.012 1.013v29.36a1.012 1.012 0 0 0 1.012 1.012h20.248a1.012 1.012 0 1 0 0-2.025Z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#155EEF",
  d: "M36.685 29.905a1.015 1.015 0 0 0-1.04.983c-.024.818-.65 1.496-1.118 1.8l-.001-.036c-.035-.667-.081-1.58-.785-2.124-1.258-.97-2.732.273-4.157 1.477-.459.403-.94.78-1.444 1.128.032-.503.09-1.004.173-1.501.236-1.6.48-3.256-.447-4.283-1.508-1.667-4.663-.472-10.552 4a1.013 1.013 0 0 0 1.225 1.612c6.622-5.029 7.815-4.264 7.824-4.254.288.318.066 1.821-.054 2.629-.228 1.546-.444 3.006.583 3.715.261.186.573.286.894.285.992 0 2.062-.904 3.105-1.785a13.64 13.64 0 0 1 1.584-1.216c.014.142.022.302.029.42.033.65.078 1.54.854 1.947.59.31 1.346.227 2.13-.232 1.053-.615 2.135-1.944 2.18-3.524a1.012 1.012 0 0 0-.983-1.041Z"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }